'use client'

import HoverItem from '../../components/hover-images/hover-item'
import Typography from '@/app/components/typography'
import { ReactNode } from 'react'

const SECTIONS: ReactNode[] = [
    (
        <>
            GIPHY is also everywhere your conversations are happening. From{' '}
            <HoverItem hoverId="imessage">iMessage</HoverItem>, to{' '}
            <HoverItem hoverId="facebook">Facebook</HoverItem>, <HoverItem hoverId="instagram">Instagram</HoverItem>
            , <HoverItem hoverId="snapchat">Snapchat</HoverItem>, <HoverItem hoverId="tiktok">TikTok</HoverItem>…
            and everywhere in-between
        </>
    ),
    (
        <>
            We are the platform where you can find the content you are passionate about — whether it be{' '}
            <HoverItem hoverId="reactions">reaction GIFs</HoverItem> for your convos,{' '}
            <HoverItem hoverId="realtime">real-time GIFs</HoverItem> of culture in action,{' '}
            <HoverItem hoverId="stickers">animated stickers</HoverItem> to layer your Stories, or
            conversation-starting <HoverItem hoverId="video">Clips</HoverItem> content.
        </>
    ),
    (
        <>
            Whether you&lsquo;re a user, <HoverItem hoverId="brand">brand</HoverItem>,{' '}
            <HoverItem hoverId="partner">content partner</HoverItem>, <HoverItem hoverId="artist">artist</HoverItem>{' '}
            — you name it — GIPHY is home to the content making your conversations and stories more positive, more
            fun, and more <HoverItem hoverId="you">you</HoverItem>.
        </>
    )
]

const InfoSection = () => (
    <div className="text-giphyWhite mx-auto max-w-(--content-max-width) text-center grid gap-[4.125rem] px-3" id="about-giphy">
        {SECTIONS.map((content, index) => (
            <Typography
                key={index}    
                variant="text-xl" 
                as="p">
                {content}
            </Typography>    
        ))}
    </div>
)

export default InfoSection
